import { useContext } from 'react';

import { ScrollContext } from '../contexts/ScrollContext.js';

/**
 * useContext wrapper for providing better API and checking if it is used within the necessary provider.
 * @internal
 */
export const useScrollContext = () => {
  const context = useContext(ScrollContext);
  if (context === undefined) {
    throw new Error('useScrollContext must be used within a ScrollProvider');
  }
  return context;
};
